import InputInterface from "./InputInterface.ts";
import FormulaInterface from "./FormulaInterface.ts";

export default class Input implements InputInterface {
    name: string;
    returnType: string;
    inputs: Map<number, InputInterface>;
    formula: FormulaInterface;

    /**
     * @param name
     * @param returnType
     * @param formula
     */
    constructor(name: string, returnType: string, formula: FormulaInterface) {
        this.name = name;
        this.returnType = returnType;
        this.inputs = new Map<number, InputInterface>();
        this.formula = formula;
    }

    getName(): string {
        return this.name;
    }

    getReturnType(): string {
        return this.returnType;
    }

    getFormula(): FormulaInterface {
        return this.formula;
    }

    /**
     * @param index
     * @param input
     */
    addInput(index: number, input: InputInterface): InputInterface {
        this.inputs.set(index, input);

        return input;
    }

    /**
     * @param index
     */
    getInput(index: number): InputInterface {
        return this.inputs.get(index);
    }

    /**
     * @param index
     */
    hasInput(index: number): boolean {
        return this.inputs.has(index);
    }

    /**
     * @param index
     */
    removeInput(index: number): void {
        this.inputs.delete(index);
    }

    serialize(): string {
        let arr = [];
        let res = '';
        let name = this.getName();
        let formula = this.getFormula();
        let args = formula.getArgs();

        args.forEach((argument, index) => {
            let input = this.getInput(index);

            if (this.hasInput(index)) {

                if ('ScalarInput' === this.getInput(index).constructor.name && '' !== input.serialize()) {
                    arr.push(input.serialize());

                } else if ('CollectionInput' === this.getInput(index).constructor.name) {
                    let collection = input.getAll();
                    let arrCollection = [];

                    for (let coll of collection) {

                        if ('ScalarInput' === coll.constructor.name && '' !== coll.serialize()) {
                            arrCollection.push(coll.serialize());

                        } else if ('Input' === coll.constructor.name) {
                            arrCollection.push(coll.serialize());

                        } else {
                            arrCollection.push(argument.getName());
                        }
                    }

                    arr.push('{' + arrCollection.join(';') + '}');

                } else if ('Input' === this.getInput(index).constructor.name) {
                    arr.push(input.serialize());

                } else {
                    arr.push(argument.getName());
                }

            } else {
                // arr.push(argument.getName());
            }
        });

        if ('root' === name) {
            res += arr.join(';');
        } else {
            res += name + '(' + arr.join(';') + ')';
        }

        return res;
    }

    setValue(value: any): void {
        throw Error();
    }

    getValue(): any {
        throw Error();
    }

    /**
     * @param value
     */
    addValue(value: any): any {
        throw Error();
    }

    getAll(): Array<any> {
        throw Error();
    }

    /**
     * @param index
     */
    hasValue(index): boolean {
        throw Error();
    }

}


// WEBPACK FOOTER //
// ./src/Models/pricingRulesInterface/Input.ts